import React, { useEffect, useState } from 'react';
import styles from './DownloadLinkDialog.module.scss';

interface DownloadLinkDialogProps {
    open: boolean;
    downloadUrl: string;
    onClose: () => void;
}

const DownloadLinkDialog: React.FC<DownloadLinkDialogProps> = ({
    open,
    downloadUrl,
    onClose
}) => {
    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
            setShowTooltip(false);
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [open]);

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(downloadUrl);
            setShowTooltip(true);
            setTimeout(() => setShowTooltip(false), 2000);
        } catch (err) {
            // Fallback для старых браузеров
            const textArea = document.createElement('textarea');
            textArea.value = downloadUrl;
            textArea.style.position = 'fixed';
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                setShowTooltip(true);
                setTimeout(() => setShowTooltip(false), 2000);
            } catch (e) {
                console.error('Failed to copy:', e);
            }
            document.body.removeChild(textArea);
        }
    };

    if (!open) return null;

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.dialog} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h2 className={styles.title}>Скачать видео</h2>
                    <button className={styles.closeButton} onClick={onClose}>
                        ×
                    </button>
                </div>
                <div className={styles.content}>
                    <p className={styles.text}>
                        Для скачивания видео скопируйте ссылку:
                    </p>
                    <div className={styles.linkContainer}>
                        <p className={styles.linkInput} onClick={handleCopyLink}>
                            {downloadUrl}
                        </p>
                        {showTooltip && <span className={styles.tooltip}>Скопировано</span>}
                    </div>
                    <p className={styles.text}>
                        Воспользуйтесь{' '}
                        <a
                            href="https://www.m3u8-to-mp4-converter.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.serviceLink}
                        >
                            сервисом для скачивания.
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default DownloadLinkDialog;

